import { ITEquipmentManagement } from "./equipment/ITEquipmentManagement";

export const ITEquipmentTab = () => {
  return <ITEquipmentManagement />;
};